export const toFloatChars = (floatStr) => {
   if (!floatStr) {
      return '';
   } else {
      return floatStr.replace(/[^\d|.]/g, '');
      // return floatStr.replace(/[^\d.]/g, '');
   }
};

// Converts the value input to string with only integers
// Handles negative value
export const toIntString = (value) => {
   const onlyNums = ('' + value).replace(/[^\d]/g, '');
   if (!onlyNums || onlyNums.length < 0) {
      return "";
   }
   return onlyNums;
};

// EXTENDS toIntString
// Removes leading zeros and handles possible overflow with string to int conversion
export const toIntStringCurrency = (value, previousValue, allowBlankValue = false) => {
   const isNegative = value.indexOf('-') > -1;
   const intStr = toIntString(value);
   let returnString = '';
   if (intStr.length > 0) {
      const parsedInt = parseInt(intStr);
      if (parsedInt === 0) {
         returnString = '';
      } else if (parsedInt > Number.MAX_SAFE_INTEGER) {
         if (previousValue) {
            returnString = '' + parseInt(toIntString(previousValue));
         } else {
            returnString = '';
         }
      } else if (parsedInt < 10) {
         returnString = '0' + parseInt(intStr);
      } else {
         returnString = '' + parseInt(intStr);
      }
   }

   return (returnString && isNegative ? '-' : '') + (allowBlankValue ? returnString : (returnString || 0));
};
